import React from "react";
import img from "./../Assets/profile3.png";
import resumePDF from "./../Assets/Swetarani-Patel-Resume.pdf"; 

const About = () => {
  const handleDownloadCV = () => {
  const a = document.createElement("a");
    a.href = resumePDF;
    a.download = "Swetarani-Patel-Resume.pdf";
    a.click();
    window.open("https://drive.google.com/file/d/1ff4RoMEnb5p8YPtdrRlCKYMS8w4ixtzQ/view?usp=drive_link", "_blank");
  };

  return (
    <section className="about" id="about">
      <div className="about-img">
        {/* <div className="outer2">
          <span></span>
          <span></span>
          <img className="image" src={img} alt="sweta" />
        </div> */}
      </div>
      <div className="about-text">
        <h2>
          About <span>Me</span>
        </h2>
        <h4>Full Stack Web Developer</h4>
        <p>
          Hey there! I'm Swetarani Patel, a passionate full stack web developer
          specializing in HTML, CSS, JavaScript, React, and Node.js. I create
          dynamic user interfaces and pixel-perfect layouts that integrate with
          robust back-end functionality. With extensive experience in front-end
          development, I utilize React to build responsive and scalable
          applications. On the server side, I work with Node.js to develop
          powerful back-end solutions, including RESTful APIs using Express.js
          and database like MongoDB.
        </p>

        <button className="btn-box" onClick={handleDownloadCV}>
          Download CV
        </button>
      </div>
    </section>
  );
};

export default About;
